import React from 'react'
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { IResEducation } from '@/lib/interfaces';
import { Plus, Trash2 } from "lucide-react";

interface IEducationDetailsSection {
  education: IResEducation[],
  setEducation: (education: IResEducation[]) => void
}

function EducationSection({ education, setEducation }: IEducationDetailsSection) {
  const addEducation = () => setEducation([...education, { institute: "", degree: "", year: "" }]);
  const removeEducation = (index: number) => setEducation(education.filter((_, i) => i !== index));
  const updateEducation = (index: number, field: string, value: string) => {
    const updated = [...education];
    (updated[index] as any)[field] = value;
    setEducation(updated);
  };

  return (
    <section className="space-y-4 p-3 bg-white 
      border-2 border-gray-200 rounded-xl">
      <div className="flex justify-between items-center">
        <h2 className="text-xl text-indigo-600 font-medium">Education Background</h2>
        <Button variant="outline" size="sm" onClick={addEducation} className="ml-4"><Plus className="w-4 h-4 mr-1" /> Add Education</Button>
      </div>
      {education.map((edu, index) => (
        <div key={index} className="grid grid-cols-1 md:grid-cols-10 gap-4 items-end border p-4 rounded-lg bg-slate-50/50">
          <div className="col-span-3 flex flex-col gap-2">
            <Label htmlFor="institute" className='text-indigo-600 ml-3'>Institute</Label>
            <Input placeholder="Institute" id="institute" className="md:col-span-1" value={edu.institute} onChange={(e) => updateEducation(index, "institute", e.target.value)} />
          </div>
          <div className="col-span-3 flex flex-col gap-2">
            <Label htmlFor="degree" className='text-indigo-600 ml-3'>Degree</Label>
            <Input placeholder="Degree" id="degree" className="md:col-span-2" value={edu.degree} onChange={(e) => updateEducation(index, "degree", e.target.value)} />
          </div>
          <div className="col-span-3 flex flex-col gap-2">
            <Label htmlFor="year" className='text-indigo-600 ml-3'>Year</Label>
            <Input placeholder="Year" id="year" type="number" value={edu.year} onChange={(e) => updateEducation(index, "year", e.target.value)} />
          </div>
          <div className="col-span-1 flex flex-row justify-end">
            <Button variant="ghost" size="icon" className="text-destructive" onClick={() => removeEducation(index)}><Trash2 size={16} /></Button>
          </div>
        </div>
      ))}
    </section>
  )
}

export default EducationSection